import SendInquiryForm from './SendInquiryForm';

export default SendInquiryForm;